import { Observable } from 'rxjs';
import {
  LoginDTO,
  LoginResponseDTO,
  RecoveryRequestDTO,
  RecoveryResponseDTO,
  ChangePassRequestDTO,
  ChangePassResponseDTO,
  ChangeProfileRequestDTO,
  ChangeProfileResponseDTO,
  AdminsDTO,
} from '../../../data/dto/LoginDTO';
import { WhatsappCodeRequest } from 'src/app/models/auth/login/whatsapp-code-request.model';
import { WhatsappCodeResponse } from 'src/app/models/auth/login/whatsapp-code-response.model';
import { LoginPhoneRequest } from 'src/app/models/auth/login/login-phone-request.model';
import { LoginPhoneResponse } from 'src/app/models/auth/login/login-phone-response.model';
import { CompleteProfileRequest } from 'src/app/models/auth/login/complete-profile-request.model';
import { CompleteProfileResponse } from 'src/app/models/auth/login/complete-profile-response.model';
import { ApiResponse } from 'src/app/auth/utils/NetworkService';

export abstract class UserRepository {
  abstract login(auth: LoginDTO): Observable<LoginResponseDTO>;
  abstract logout(): Observable<string>;
  abstract recover(request: RecoveryRequestDTO): Observable<RecoveryResponseDTO>;
  abstract recoverWati(request: RecoveryRequestDTO): Observable<RecoveryResponseDTO>;
  abstract changePass(request: ChangePassRequestDTO): Observable<ChangePassResponseDTO>;
  abstract changeProfile(request: ChangeProfileRequestDTO): Observable<ChangeProfileResponseDTO>;
  abstract admins(): Observable<AdminsDTO>;
  abstract getCode(request: WhatsappCodeRequest): Observable<WhatsappCodeResponse>;
  abstract loginWithPhone(request: LoginPhoneRequest): Observable<ApiResponse<LoginPhoneResponse>>;
  abstract registerOneTime(request: WhatsappCodeRequest): Observable<WhatsappCodeResponse>;
  abstract completeOneTimeProfile(request: CompleteProfileRequest): Observable<CompleteProfileResponse>;
}
